import promiseRetry from 'promise-retry';
export function promiseWithRetries(promiseFn, _ref) {
  let {
    retries,
    onRetry
  } = _ref;
  return promiseRetry((retry, attempt) => Promise.resolve().then(() => promiseFn({
    attempt
  })).catch(error => {
    if (attempt < retries) {
      onRetry === null || onRetry === void 0 ? void 0 : onRetry(error, attempt);
      return retry(error);
    }
    throw error;
  }));
}
//# sourceMappingURL=promiseWithRetries.js.map